import React from 'react';
import * as PropTypes from 'prop-types';
// import cx from 'classnames';
import Button from '../Button';
import Close from '../Close';
import Icon from '../../../Icon';
import ZzbList from '../ZzbList';
import headerImage from './header@3x.jpg';
import { gotoLogin, isLogin } from '../../../../util-lib/login/login-controller';
import './style.scss';

const ZzbHome = (
  {
    awards, day, onRuleButtonClick, onClose, onStartCountdown
  }
) => {
  const finishDay = awards.filter(_ => _.status > 0).length;
  const todayAward = awards.find(_ => _.offset === day);
  const todayIsDone = !!todayAward && todayAward.status > 0;
  const dayProgressText = `(${finishDay}/7天)`;
  const buttonText = todayIsDone ? `今天已完成${dayProgressText}` : `去完成 ${dayProgressText}`;
  return (
    <article className="ap-home ap-zzb-home">
      <section className="ap-home-main">
        <section className="ap-home-body ap-zzb-home-body" style={{ backgroundImage: `url(${headerImage})` }}>
          <section className="ap-zzb-home-rule-button" onClick={onRuleButtonClick}>
            <p>规</p>
            <p>则</p>
            <Icon name="arrow_new" className="icon-arrow" />
          </section>
          <section className="ap-home-progress ap-zzb-home-progress">
            <ZzbList
              day={day}
              data={awards}
              onClick={
                (award) => {
                  if (!isLogin()) {
                    gotoLogin();
                    return;
                  }
                  const { status, offset } = award;
                  if (status !== 1) {
                    return;
                  }
                  window.location.href = `/tantu/webapp/punch/landing?receiveZzbOffset=${offset}&ZZCAppArg=topBar_Hidden`;
                }
              }
            />
            <p className="ap-zzb-home-notice">
              {
                day > 0 && '若打卡中断，就会重新开始哦~'
              }
            </p>
            <section className="ap-home-go">
              <Button text={buttonText} onClick={todayIsDone ? null : onStartCountdown} size="large" />
            </section>
          </section>
        </section>
      </section>
      <section className="ap-home-close">
        <Close onClick={onClose} />
      </section>
    </article>
  );
};

ZzbHome.propTypes = {
  awards: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  day: PropTypes.number.isRequired,
  onRuleButtonClick: PropTypes.func.isRequired,
  // onAwardItemClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  // onGoToMall: PropTypes.func.isRequired,
  onStartCountdown: PropTypes.func.isRequired
};

export default ZzbHome;
